import React from 'react';
import { Spinner } from 'react-bootstrap';

const SmallSpinner = () => (
    <div
        style={{
            position: 'absolute',
            width: '16px',
            height: '16px',
            right: '10px',
            top: '50%',
            transform: 'translateY(-50%)',
            margin: 0,
            zIndex: 10
        }}
    >
        <Spinner
            animation='border'
            variant='secondary'
            style={{
                position: 'absolute',
                right: '0%',
                top: '0%',
                width: '100%',
                height: '100%',
                margin: 0,
                borderWidth: '0.20em'
            }}
        />
    </div>
);

export default SmallSpinner;
